import http_service from "../classes/http";
import { bus } from '../other/bus'

let http = new http_service(bus);
export default {
  namespaced: true,
  state: {
    trainers: [],
    gorbov_params: {
      start: false,
      finish: false,
      size: 3,
      show_reactions: false
    },
    mnemo_params: {
      get_ready: false,
      start: false,
      finish: false,
      size: 3,
      show_reactions: false
    },
    texts_params: {
      start: false,
      finish: false,
      show_reactions: false,
      text_id: 3,
      text: '',
      mode: 'nochange',
      selected_mode: '',
    },
    wedge_params: {
      start: false,
      finish: false,
      show_reactions: false,
      mode: 'digits',
      orientation: 'column',
      digits_count: 1,
      letters_count: 4,
      rows: 10
    },
    bee_params: {
      start: false,
      finish: false,
      show_reactions: false,
      size: 3,
      min_steps: 3,
      max_steps: 5,
      speed: 0.5,
      mode: 'where',
      sounds: true,
      users: 1
      // modes - out, where, path
    },
    spritz_params: {
      start: false,
      finish: false,
      show_reactions: false,
      text_id: 3,
      text: '',
      speed: 100
    },
    strup_params: {
      start: false,
      finish: false,
      show_reactions: false,
      mode: 'words',
      sounds: false,
      steps: 50,
      speed: 0.5,
      users: 1
    },
    alphabet_params: {
      start: false,
      finish: false,
      show_reactions: false,
      mode: 'words',
      sounds: false,
      steps: 3,
      size: 5,
      speed: 2,
      users: 1
    },
    speedtest_params: {
      start: false,
      finish: false,
      show_reactions: false,
      show_mode: true,
      countdownSeconds: 60,
      text_id: 3,
      text: ''
    },
    metronom_params: {
      start: false,
      finish: false,
      bpm: 120,
      has_accent: true,
      sounds: true
    },
  },
  mutations: {
    changeParams(store, val){
      store[val.train] = val.params;
    },
    changeParam(store, val){
      store[val.train][val.param_name] = val.param_val;
    },
    setTrainers(state, items) {
      state.trainers = items;
    }
  },
  actions: {
    async getTrainers(ctx) {
      let trainers = await http.post('onGetTrainers').then(res => res.data)
      console.log(trainers)
      ctx.commit('setTrainers', trainers);
    },
  },
  getters: {
    trainers(state) {
      return state.trainers
    },
    trainerByName(state) {
      return (component) => {
        return state.trainers.find(item => item.component === component)
      }
    },
    params(state) {
      return (name) => {
        return state[name + '_params']
      }
    }
  }
}